module.exports = __webpack_public_path__ + "static/img/2.72381f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/2.png
// module id = wzLE
// module chunks = 0